import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Edit,
  TextInput,
  SelectInput,
  SimpleForm,
  required,
  choices,
  TopToolbar,
  ListButton,
  ShowButton,
  useNotify,
  useRefresh,
} from "react-admin";

const ProviderActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const ProvidersEdit = (props) => {
  const today = new Date();

  const validateRelation = choices(
    ["Friend/Family", "Customer", "Partner", "Other"],
    "Please choose one of the values"
  );

  const notify = useNotify();
  const refresh = useRefresh();
  // const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Changes saved`);
    // redirect("/posts");
    refresh();
  };
  return (
    <Edit
      title="Edit Provider"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<ProviderActions />}
      {...props}
    >
      <SimpleForm>
        <TextInput
          label="Company name"
          source="name"
          validate={required("Company name is required")}
        />
        <TextInput
          label="Reference contact name"
          source="contact_name"
          validate={required("Reference contact name is required")}
        />
        <TextInput
          label="Reference contact position"
          source="contact_position"
        />
        <SelectInput
          label="Relation"
          source="relation"
          choices={[
            { id: "Friend/Family", name: "Friend/Family" },
            { id: "Customer", name: "Customer" },
            { id: "Partner", name: "Partner" },
            { id: "Other", name: "Other" },
          ]}
          validate={validateRelation}
        />

        <TextInput label="Email address" source="email" type="email" />

        <TextInput label="Phone number" source="phone_number" />
      </SimpleForm>
    </Edit>
  );
};

export default ProvidersEdit;
